import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ClientInterface } from '../data';
import { ContractProvider } from '../providers/contract.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetPupilsUseCaseParams {
    client: ClientInterface;
}

@Injectable()
export class GetPupilsUseCase implements UseCaseWithParam<GetPupilsUseCaseParams, Observable<Transaction<ClientInterface[]>>> {
    constructor(private contractProvider: ContractProvider) {}

    bind(params: GetPupilsUseCaseParams): Observable<Transaction<ClientInterface[]>> {
        return this.contractProvider.current().pipe(
            map((transaction) =>
                transaction.map(
                    (contract) => {
                        const pupils: ClientInterface[] = [];

                        let isLegalGuardian = false;

                        contract.legalGuardians.map((legalGuardian) => {
                            if (legalGuardian.id.value === params.client.id.value) {
                                isLegalGuardian = true;
                            }
                        });

                        if (isLegalGuardian) {
                            contract.holders.map((holder) => {
                                holder.legalGuardians.map((legalGuardian) => {
                                    if (
                                        legalGuardian.id.value === params.client.id.value &&
                                        !pupils.find((it) => it.id.value === holder.id.value)
                                    ) {
                                        pupils.push(cloneDeep(holder));
                                    }
                                });
                            });
                        }

                        return Transaction.success(pupils);
                    },
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
